import type { ReactNode } from "react";
import { TbCornerLeftUpDouble } from "react-icons/tb";
import { ThemeToggle } from "@/components/ui/ThemeToggle";

/** Centered card layout shared by the public account pages (registro, recuperación de contraseña). */
export function AuthShell({ title, description, children, footer }: {
    title: string;
    description: string;
    children: ReactNode;
    footer?: ReactNode;
}) {
    return (
        <div className="relative flex min-h-screen flex-col justify-center bg-background px-6 py-12 sm:px-10">
            <div
                className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,hsl(var(--primary)/0.08),transparent_50%)]"
                aria-hidden
            />
            <ThemeToggle className="absolute right-4 top-4 z-10 sm:right-6 sm:top-6" />

            <div className="relative mx-auto w-full max-w-lg">
                <div className="mb-8 flex flex-col items-center text-center">
                    <div className="mb-6 flex items-center justify-center gap-3 lg:mb-8">
                        <TbCornerLeftUpDouble className="size-10 text-primary" aria-hidden />
                        <span className="text-xl font-semibold tracking-tight">Automatari</span>
                    </div>
                    <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
                    <p className="mt-2 text-sm text-muted-foreground sm:text-base">{description}</p>
                </div>

                <div className="rounded-2xl border border-border/60 bg-card/80 p-6 shadow-sm backdrop-blur-sm sm:p-8">
                    {children}
                </div>

                {footer ? <p className="mt-6 text-center text-sm text-muted-foreground">{footer}</p> : null}
            </div>
        </div>
    );
}
